import React from "react";
import { generateFtcPdf } from "./generator";
import PdfBase from "../../Others/Pdf/PdfBase";
import ExcelBase from "../../Others/Excel/ExcelBase";

const PdfGenerator = ({
  schedule,
  company,
  functionalCurrency,
  functionalCurrencyRate,
  breakdownRows,
  foreignIncomeRows,
  foreignIncomeTotals,
  ftcCalculatedData,
  notes,
  reviewNotes,
}) => {
  const sharedArgs = [
    schedule,
    company,
    functionalCurrency,
    functionalCurrencyRate,
    breakdownRows,
    foreignIncomeRows,
    foreignIncomeTotals,
    ftcCalculatedData,
    notes,
    reviewNotes,
  ];
  return (
    <>
      <PdfBase
        company={company}
        enableDraftView
        generatePdf={(forView) => generateFtcPdf(forView, ...sharedArgs)}
        downloadName='Foreign Tax Credit Schedule'
      />
      <ExcelBase
        generateExcel={(forView) =>
          generateFtcPdf(forView, ...sharedArgs, true)
        }
      />
    </>
  );
};

export default PdfGenerator;
